//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import noticeApi from '@/api/notice'
import CardItem from '@/components/b5News/CardItem'
export default {
  name: 'Index',
  components: { CardItem },
  props: {
    params: {
      type: Object,
      default() {
        return {
          id: 123,
        }
      },
    },
  },
  async asyncData({ app,query }) {
    const options = {
      type: +query.type || 0,
      pageNo: +query.pageNo || 1,
      pageSize: +query.pageSize || 20,
    }
    let tempData
    const [err, data] = await noticeApi
      .getNoticeList(app,options)
      .then((data) => [null, data])
      .catch((err) => [err, null])  
    if (err) {
      // 对错误进行处理
      console.log({ err })
    }
    if (Array.isArray(data.data)) {
      tempData = data.data
    } else {
      tempData = []
    }
    return {
      prefetchedData: tempData,
    }
  },
  data() {
    return {
      activeItem: 0,
      baseImgUrl: 'https://img.b5csgo.com.cn',
      receivedData: [],
      activeArr: [],
      pageNo: 1,
      pageSize: 20,
      totalPage: null,
      // 数据是否到底
      nomore: false,
    }
  },
  computed: {
    noticeArr() {
      if (this.receivedData && this.receivedData.length > 0) {
        return this.receivedData.filter((i) => i.type === 2)
      }
      return []
    },
    raceArr() {
      if (this.receivedData && this.receivedData.length > 0) {
        return this.receivedData.filter((i) => i.type === 1)
      }
      return []
    },
  },
  mounted() {
    this.receivedData = this.prefetchedData
    this.filterData(this.activeItem)
  },
  methods: {
    // 获取公告列表
    fetchData() {
      const options = {
        type: this.activeItem,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      noticeApi
        .getNoticeList(this,options)
        .then((response) => {
          const { data, code } = response
          if (code === 0 && Array.isArray(data)) {
            if (data.length > 0) {
              this.receivedData = [...this.receivedData, ...data]
              this.filterData(this.activeItem)
            } else {
              this.nomore = true
            }
          } else {
            throw new Error(response.msg)
          }
        })
        .catch((e) => {
          console.log({ erro: e })
        })
    },

    // 切换过滤数据
    setActiveType(type) {
      this.activeItem = type
      this.filterData(type)
    },

    // 切换过滤数据
    filterData(type) {
      switch (type) {
        case 2:
          this.activeArr = this.noticeArr
          break
        case 1:
          this.activeArr = this.raceArr
          break
        default:
          this.activeArr = this.receivedData
      }
    },

    // 查看更多
    fetchMore() {
      this.pageNo += 1
      if (!this.nomore) {
        this.fetchData()
      } else {
        // 暂无数据
        return false
      }
    },
  },
}
